import type { IEventChannel, ApiOpts } from "../model/Models";
import type AjaxRequestBroker from "../AjaxRequestBroker";
import type CacheModule from "./CacheModule";

const es = global.es;

/**
 * @class Search
 */
export default class SearchModule {
    private eventChannel: IEventChannel;
    private rqBroker: AjaxRequestBroker;
    private resourceName: string;
    private cache: CacheModule;
    
    /**
     * 
     * @param eventChannel 
     * @param rqBroker 
     * @param resourceName 
     * @param cache 
     */
    constructor(eventChannel: IEventChannel, rqBroker: AjaxRequestBroker, resourceName: string, cache: CacheModule) {
        this.eventChannel = eventChannel;
        this.rqBroker = rqBroker;
        this.resourceName = resourceName;
        this.cache = cache;

        // TODO FIXME Does this even make sense nowadays?
        eventChannel.addListener("onDestroy", () => {
            // prevent memory leaks when the map widget is destroyed
            this.eventChannel = this.rqBroker = this.resourceName = this.cache = null;
        });

        this.search = this.search.bind(this);
    }

    /**
     * Search layer meta and geo map title attribute.
     *
     * @param searchStr is not case-sensitive. null/undefined/empty string returns most recently updated
     * @param opts
     * 
     * @returns
     */
    search(searchStr?: string, opts?: ApiOpts) {
        if (searchStr === undefined || searchStr.trim().length === 0){
            searchStr = "";
        }

        const url = es.api.getURL(this.resourceName) + "/all?text=" + es.util.url.stringify(searchStr);

        return this.rqBroker.doGet({
            url: url,
            opts: opts
        });
    }
}
